export enum PaymentRoutes {
  // Partner routes
  GETTING_STARTED = "/getting-started",
  INVOICES = "/invoices",
  LOADING = "/loading",
  PAYOUTS = "/payouts",
  PAYOUT_DETAILS = "/payouts/:payout_id",
  PAYOUT_UPCOMING = "/payouts/upcoming",
  PAYOUT_INCOMING = "/payouts/incoming",
  PAYOUT_TROUBLESHOOT = "/payouts/:payout_id/troubleshoot",
  CUSTOMERS = "/customers",
  CUSTOMERS_DETAILS = "/customers/:id",
  TRANSACTIONS = "/transactions",
  PAYMENT_LINKS = "/payment-links",
  SETTINGS_CONFIG = "/settings/config",
  SETTINGS_INTEGRATION = "/settings/integration",
  SETTINGS_USERS = "/settings/users",
  REGISTER = "/register",
  ACCEPT_USER_INVITE = "/team/accept-invite/:team_invite_id",
  ONBOARDING_FORM = "/onboarding/start",
  ADD_PAYMENT_METHOD_MANDATE = "/mandateRequest/addAuthorizationMandate/:id",
  CHECKOUT_INVOICE_PAY = "/checkout/invoice/pay/:customer_id/:invoice_id",
  CHECKOUT_INVOICE_COLLECT = "/checkout/invoice/collect/:customer_id/:invoice_id",
  CHECKOUT_PAYMENT_LINK = "/paymentlink/checkout/:customer_id/:id",
  INVOICE_RECEIPT = "/invoice/receipt/:customer_id/:transaction_id",
  REFUND_RECEIPT = "/transactions/:transaction_id/receipt",
  // Error routes
  INTERNAL_SERVER_ERROR = "/error/500",
  SESSION_ENDED = "/error/session-ended",
  ACCOUNT_CANCELLED = "/account-cancelled",
  // Client portal routes
  CLIENT_PORTAL_LOGIN = "/client-portal/:id",
  CLIENT_PORTAL_INVOICES = "/client-portal/invoices",
  CLIENT_PORTAL_CUSTOMERS = "/client-portal/customers",
  CLIENT_PORTAL_CUSTOMERS_DETAILS = "/client-portal/customers/:customerId",
  ZOMENTUM_GROW_QUOTE_PAY = "/zomentum-grow/quote/pay/:id",
  QUICKBOOKS_SETTINGS = "/quickbooks/settings",
  XERO_SETTINGS = "/xero/settings",
  INVOICE_AUTO_COLLECT_DETAIL = "/invoice/:invoice_id/autoCollect/:auto_collect_id",
  // Admin routes
  ADMIN_TEAMS = "/admin/teams",
  ADMIN_TEAM_DETAIL = "/admin/teams/:team_id",
  ADMIN_TEAM_TRANSACTION_LIST = "/admin/teams/:team_id/transactions",
  ADMIN_TEAM_TRANSFERS_LIST = "/admin/teams/:team_id/transfers",
  ADMIN_TEAM_USER_LIST = "/admin/teams/:team_id/users",
  ADMIN_TEAM_PAYOUTS_LIST = "/admin/teams/payouts/:team_id",
  ADMIN_TEAM_PAYOUT_TROUBLESHOOT = "/admin/teams/:team_id/payouts/:payout_id/troubleshoot"
}

export const ERROR_PAGES: readonly string[] = [
  PaymentRoutes.INTERNAL_SERVER_ERROR,
  PaymentRoutes.SESSION_ENDED,
  PaymentRoutes.ACCOUNT_CANCELLED
];

export const isErrorPage = (pathname: string): boolean => {
  return ERROR_PAGES.includes(pathname);
};
